import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import * as fselib from 'mercalink-fselib'; 
import * as util from "@app/shared/util";

import { environment } from '@app/../environments/environment';
import * as constants from "@app/shared/constants";

export interface DialogData {
	index: number;
	beneficiaire: fselib.Beneficiaire;
	empreinteCV: fselib.EmpreinteCV;
}

@Component({
    selector: 'lib-recipient',
    imports: [MatIconModule],
    templateUrl: './recipient.component.html',
    styleUrls: ['./recipient.component.scss'],
		changeDetection: ChangeDetectionStrategy.Eager,
		standalone: true,
})
export class RecipientComponent {
	public fselib = fselib;
	public constants = constants;
	public beneficiaire!: fselib.Beneficiaire;
	public empreinteCV!: fselib.EmpreinteCV;
	readonly dialogdata = inject<DialogData>(MAT_DIALOG_DATA as any);	// 'as any' tricks the compiler
	public util = util;
	
	readonly SituationSpecifiqueDescriptions: { [key in string]: string } = {
			"00": "Néant",
			"01": "C2S par AMO",
			"02": "C2S par AMC conv. ou AMO",
			"03": "C2S par AMC",
	    "10": "Bénéficiaire sortant de C2S",
			"11": "Dispositif d'aide à l'acquisition d'une AMC",
			"12": "ACS A",
			"13": "ACS B",
			"14": "ACS C",
	};	
	
	constructor( private dialog: MatDialog) { }	
	
	ngOnInit() {
		this.beneficiaire = this.dialogdata.beneficiaire;
		this.empreinteCV = this.dialogdata.empreinteCV;
		console.log('beneficiaire: ', JSON.stringify(this.beneficiaire, null, 2));
		}	
}
